import React from "react";

import cx from "classnames";
import { connect } from "react-redux";

import LegislativePopup from "./legislativePopup";

function Group(props) {
  const { governmentBody } = props;
  const cls = cx("house-buttons", {
    "assembly-buttons": governmentBody === "Assembly",
    "group-buttons": governmentBody !== "Assembly",
  });
  return (
    <div className={cls}>
      {props.representatives.map((person, i) => (
        <LegislativePopup
          key={i}
          info={person}
          genderFilter={props.genderFilter}
          raceFilter={props.raceFilter}
          regionFilter={props.regionFilter}
          committeeFilter={props.committeeFilter}
          governmentBody={props.governmentBody}
        />
      ))}
    </div>
  );
}

function mapStateToProps(state, ownProps) {
  if (ownProps.representatives) {
    return {
      representatives: ownProps.representatives,
    };
  } else {
    return { representatives: [{ "": "" }] };
  }
}

const componentCreator = connect(mapStateToProps);
export default componentCreator(Group);
